export function blankParagraph() {
    return { tag: "w:p", children: [{tag: "w:pPr", children: [
        { tag: "w:spacing", attrs: {  "w:after":"0", "w:line": "240", "w:lineRule": "auto" } }
    ]}]};
}

export function cloneOOXMLData(data, parentOOXML) {
    let result = {
        _attrs: data._attrs || {},
        _fTextNode: data._fTextNode,
        _children: [],
        _parent: parentOOXML,
    };
    if (data._tag) result._tag = data._tag;
    if (data._text) result._text = data._text;
    if (data._children) data._children.map((child) => result._children.push(cloneOOXMLData(child, result)));
    return result;
}


export function convertToOOXML(data, parentOOXML) {
    let result = { _attrs: data.attrs || {}, _children: []};
    if (parentOOXML) result._parent = parentOOXML;

    if (data.tag === "TEXT_NODE") {
        result._fTextNode = true;
        result._text = data.children;
    } else {
        result._tag = data.tag;
        result._fTextNode = false;
        
        if (data.children) data.children.forEach((child) =>
            result._children.push(convertToOOXML(child, result))
        );

        if (data.ooxmlChildren) data.ooxmlChildren.forEach((child) =>
            result._children.push(cloneOOXMLData(child, result))
        );
    }

    return result;
}


/**
 * 
 * @param {Node} node 
 */
export function removeParagraph(doc, node) {
    if (node.nodeType === Node.ELEMENT_NODE) {
        const newChildren = [];
        let child;
        do {
            child = node.childNodes[0];
            if (child) {
                const removedNodes = removeParagraph(doc, child);
                if (Array.isArray(removedNodes)) newChildren.push(...removedNodes);
                else newChildren.push(removedNodes);
                node.removeChild(child);
            }
        } while(child);
        newChildren.forEach(child => node.appendChild(child));

        if (node.nodeName === 'P' && node.childNodes.length > 0) { 
            const children = []
            node.childNodes.forEach(child => {
                children.push(child);
            });
            children.push(doc.createElement('br')); 
            return children;
        }
    } 

    return node;
}


export function runOnChild(xml, childTest, callback) {
    if (xml._children) {
        xml._children.forEach(child => {
            if (childTest(child)) {
                callback(child);
            } else {
                runOnChild(child, childTest, callback);
            }
        });
    }
}